import { useIsProjectTechnicalWriter } from "@/auth/permissions";
import { useFullReleaseStrict } from "@/common/hooks_useFullRelease";
import { TemplateField } from "@/components/TemplateField";
import { TriggerIntroduction } from "@/features/triggers/components/TriggerGuidance";
import CheckboxField from "@imminently/decisively-ui/CheckboxField";
import FormPanel from "@imminently/decisively-ui/FormPanel";
import SelectField from "@imminently/decisively-ui/SelectField";
import TextField from "@imminently/decisively-ui/TextField";

export const AttributeStorageForm = ({ scope }: { scope: string }) => {
  const scopedValue = (name: string) => `${scope}.${name}`;
  const release = useFullReleaseStrict();
  const canEdit = useIsProjectTechnicalWriter();

  // Get response mappings from the release
  const responseMappings = release.mapping?.filter((mapping) => mapping.type === "response") || [];
  const mappingOptions = responseMappings.map((mapping) => ({
    label: mapping.name,
    value: mapping.id || mapping.name,
  }));
  const deltaMappings = release.mapping?.filter((mapping) => mapping.type === "delta") || [];
  const deltaMappingOptions = deltaMappings.map((mapping) => ({
    label: mapping.name,
    value: mapping.id || mapping.name,
  }));

  return (
    <FormPanel>
      <TriggerIntroduction type="storage" />
      <FormPanel>
        <TemplateField
          label="File Name"
          name={scopedValue("title")}
          disabled={!canEdit}
        />
        <TextField
          label="Container"
          name={scopedValue("container")}
          disabled={!canEdit}
          fullWidth
        />
        <CheckboxField
          label="Append"
          name={scopedValue("append")}
          disabled={!canEdit}
        />
        <SelectField
          label="Mapping"
          name={scopedValue("mapping")}
          options={mappingOptions}
          disabled={!canEdit}
          fullWidth
        />
        <SelectField
          label="Delta Mapping (optional)"
          helperText="Optional: calculate delta records first, then apply the selected response mapping for output formatting."
          name={scopedValue("deltaMapping")}
          options={deltaMappingOptions}
          disabled={!canEdit}
          fullWidth
        />
      </FormPanel>
    </FormPanel>
  );
};
